var render = function () {
  var _vm$ticket, _vm$ticket$details, _vm$ticket2, _vm$ticket2$details;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-sheet', {
    staticClass: "d-flex flex-column flex-sm-row align-stretch justify-center justify-sm-start rounded-lg mt-4 pa-4",
    attrs: {
      "max-width": "850",
      "width": "100%"
    }
  }, [_c('v-sheet', {
    staticClass: "d-flex align-start justify-center mx-auto mx-sm-0 mb-2 mb-sm-0",
    attrs: {
      "height": "100%",
      "max-width": "33%",
      "min-width": "33%",
      "width": "33%"
    }
  }, [_c('img', {
    staticClass: "ticket-logo rounded-lg",
    attrs: {
      "src": _vm.ticket.logo,
      "alt": ("logo for " + (_vm.ticket.title))
    }
  })]), _c('v-card', {
    staticClass: "d-flex flex-column ml-0 ml-sm-4",
    attrs: {
      "flat": "",
      "title": ""
    }
  }, [_c('v-card-title', {
    staticClass: "text-h5 primary--text font-weight-bold break-word pa-0",
    domProps: {
      "innerHTML": _vm._s(_vm.ticket.title)
    }
  }), _c('v-card-text', {
    staticClass: "d-flex flex-column align-start justify-start pa-0"
  }, [_vm.ticket.price ? _c('p', {
    staticClass: "text-body-1 font-weight-bold success--text"
  }, [_vm._v(" " + _vm._s(_vm.ticket.price) + " "), _c('span', {
    staticClass: "black--text text-caption font-weight-light"
  }, [_vm._v("(" + _vm._s(_vm.ticket.expiration ? ("expires " + (_vm.ticket.expiration)) : 'no expiration') + ")")])]) : _vm._e(), _vm.ticket.discount ? _c('p', {
    staticClass: "text-body-1 font-weight-bold success--text"
  }, [_vm._v(" " + _vm._s(_vm.ticket.discount) + " discount"), _vm.ticket.expiration ? _c('span', {
    staticClass: "black--text text-caption font-weight-light"
  }, [_vm._v("(" + _vm._s(_vm.ticket.expiration) + ")")]) : _vm._e()]) : _vm._e(), (_vm$ticket = _vm.ticket) !== null && _vm$ticket !== void 0 && (_vm$ticket$details = _vm$ticket.details) !== null && _vm$ticket$details !== void 0 && _vm$ticket$details.length ? [((_vm$ticket2 = _vm.ticket) === null || _vm$ticket2 === void 0 ? void 0 : (_vm$ticket2$details = _vm$ticket2.details) === null || _vm$ticket2$details === void 0 ? void 0 : _vm$ticket2$details.length) > 1 ? _c('ul', {
    staticClass: "py-4 py-sm-8",
    staticStyle: {
      "max-width": "150ch"
    }
  }, _vm._l(_vm.ticket.details, function (detail, k) {
    return _c('li', {
      key: k
    }, [_vm._v(_vm._s(detail))]);
  }), 0) : _c('p', {
    staticClass: "py-8"
  }, [_vm._v(_vm._s(_vm.ticket.details[0]))])] : _vm._e()], 2), _c('v-card-actions', {
    staticClass: "pt-4 pa-sm-0 mt-auto d-flex flex-row justify-space-start"
  }, [_vm.ticket.homepage ? _c('v-btn', {
    staticClass: "font-weight-bold",
    attrs: {
      "color": "primary",
      "href": _vm.ticket.homepage,
      "outlined": "",
      "target": "_blank"
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "color": "primary"
    }
  }, [_vm._v("mdi-home")]), _vm._v("HOME")], 1) : _vm._e(), _vm.ticket.ticket_url ? [_vm.ticket.ticket_url === 'eipl' ? _c('v-btn', {
    attrs: {
      "color": "primary"
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "color": "secondary"
    }
  }, [_vm._v("mdi-library-outline")]), _vm._v("LIBRARY PICKUP")], 1) : _c('v-btn', {
    staticClass: "font-weight-bold",
    attrs: {
      "color": "primary",
      "href": _vm.ticket.ticket_url,
      "target": "_blank"
    }
  }, [_c('v-icon', {
    attrs: {
      "left": "",
      "color": "secondary"
    }
  }, [_vm._v(_vm._s(("mdi-" + (_vm.isPass ? 'bank' : 'ticket-outline'))))]), _vm._v(_vm._s(_vm.isPass ? 'RESERVE' : 'TICKETS'))], 1)] : _vm._e()], 2)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }